const config = { attributes: false, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      const target = '/pages/mein-konto?return_to=' + encodeURIComponent(location.pathname + location.search);
      const loginLock = document.querySelectorAll('.bss-lock-element > a');
      loginLock.forEach(message => {
        if (message.getAttribute('href') !== target) {
          message.setAttribute('href', target);
        }
        message.removeAttribute('target');
      });
    }
  }
};

const observer = new MutationObserver(callback);
observer.observe(document.body, config);